// extracted by mini-css-extract-plugin
export default {"paymentWrap":"DexPayment_paymentWrap__rZsp+","planTitle":"DexPayment_planTitle__OtZmj","paymentInnerWrap":"DexPayment_paymentInnerWrap__Lm8ER","warning":"DexPayment_warning__kzrxa"};